import { Pipe, PipeTransform } from '@angular/core';
import { ICartProduct } from 'app/models/cart.model';

@Pipe({
  name: 'cartProductName'
})
export class CartProductNamePipe implements PipeTransform {

  transform(cartProduct: ICartProduct): string {
    let resultName = cartProduct.name;

    if (cartProduct.selectedSizeId && cartProduct.product.sizes && cartProduct.product.sizes.length){
      const size = cartProduct.product.sizes.find(s => s.id == cartProduct.selectedSizeId);
      const sizeName = size?.name;
      if(sizeName){
        resultName = `${resultName} (${sizeName})`;
      }
    }

    return resultName;
  }
}
